import * as React from 'react';

import { useSafeLayoutEffect } from './useSafeLayoutEffect';

/**
 * Return a reference that always hold the value of the last render.
 */
export function useLiveRef<T>(value: T): React.MutableRefObject<T> {
    const ref = React.useRef(value);
    useSafeLayoutEffect(() => {
        ref.current = value;
    });
    return ref;
}
